import { useEffect, useState } from 'react';

import { Form } from '@/components-ant/form';
import { FormModal } from '@/components-ant/form-modal';
import { Input } from '@/components-ant/input';
import { Result } from '@/shared/helpers/Result';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string) => Promise<Result>;
};

export function AddViewModal({ isOpen, onClose, onSubmit }: Props) {
  const [form] = Form.useForm();
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    form.resetFields();
  }, [form, isOpen]);

  const submit = async (formData: any) => {
    setIsSaving(true);
    const result = await onSubmit(formData.name.trim());
    if (result.isSuccess) onClose();
    setIsSaving(false);
  };

  return (
    <FormModal
      onSave={() => form.submit()}
      isSaving={isSaving}
      open={isOpen}
      onCancel={onClose}
      title="Create a saved view"
      description="Create a new saved view with the currently applied filters."
    >
      <Form form={form} layout="vertical" name="addView" onFinish={submit}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter a name for the view' }]}
        >
          <Input autoFocus />
        </Form.Item>
      </Form>
    </FormModal>
  );
}
